import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteContactPayload } from '@app-store/slices/contacts/delete'

interface TaskAction extends Action {
    payload: IDeleteContactPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.contacts.delete

function* deleteContactSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/contacts/${payload.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Contact deleted successfully.'
            })
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteContactSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteContactSagaTask)
}

export default deleteContactSaga
